import React from 'react';
import PropTypes from 'prop-types';
import { addUrlProtocol } from '@Utils/String';

import { LinkElement } from '@els/els-react--link-element';

export default function WebAddress(props) {
  const { text, handleClick } = props;
  const url = addUrlProtocol(text);
  return (
    <LinkElement
      data-e2e="rcs-supplier-info-web-address"
      href={url}
      isExternal
      iconEmphasis
      onClick={() => handleClick && handleClick(url)}
      className="e2e-rcs-supplier-info-WebAddress">
      {text}
    </LinkElement>
  );
}

WebAddress.propTypes = {
  text: PropTypes.string.isRequired,
  handleClick: PropTypes.func,
};
